export default class elasticsearchService {
    constructor() {
        this.user_id = $('.user-data').attr('data-user-id');
        this.session_id = $('.user-data').attr('data-session-id');
        this.url = {
            origin: "https://account.envoituresimone.com",
            api: {
                locations: "/api/v1/locations",
                availability: "/api/v1/availability",
                group_availability: "/api/v1/group_availability",
                count_availabilities: "/api/v1/availabilities/count",
                history: "/api/v1/user_navigation",
                teachers: "/api/v1/teachers"
            }
        };
    }

    ajax(type, path, data, options = {}) {
        var params = {
            type: type,
            async: false,
            contentType:  'application/json',
            processData: true,
            url: this.getUrl(path)
        };

        if (Object.keys(data).length !== 0){
            params['data'] = data
        }

        return $.ajax(params)
    }

    getUrl(path) {
        return this.url.origin + path;
    }

    get(path, data = {}, header = {}){
        return this.ajax('GET', path, data, {headers: header}).responseJSON
    }

    post(path, data = {}, header = {}){
        return this.ajax('POST', path, data, {headers: header}).responseJSON
    }

    saveUserNavigation(requested_address, select_point) {
        var params = {
            "session_id": this.session_id,
            "user_id": this.user_id ? this.user_id : null,
            "requested_address": {
                "coordinate": [requested_address["lat"], requested_address["lng"]],
                "adress_name": requested_address["name"]
            },
            "select_point": {
                "location_id": select_point["location_id"],
                "name": select_point["name"],
                "coordinate": [select_point["lat"], select_point["lng"]],
                "mapping_dispo": select_point["mapping_dispo"]
            }
        };
        this.post(this.url.api.history, JSON.stringify(params));
    };

    searchLocation(params) {
        return this.get(this.url.api.locations, params);
    }

    searchCountAvailabilities() {
        return this.get(this.url.api.count_availabilities);
    }

    searchAvailability(params) {
        let url = this.url.api.availability + "/" + params.location_id;
        return this.get(url);
    }

    searchAvailabilities(params) {
        return this.post(this.url.api.availability, JSON.stringify(params));
    }

    searchGroupAvailability(params) {
        return this.post(this.url.api.group_availability, JSON.stringify(params));
    }

    searchTeachers(params) {
        return this.post(this.url.api.teachers, JSON.stringify(params));
    }


}
